export default "__VITE_ASSET__D$nlp2lB__"